import React__default, { useState } from 'react';
import styles from './styles.module.scss.js';
import propsToClass from '../../../helpers/propsToClass.js';
import uniqueId from '../../../helpers/uniqueId.js';
import { COLORS } from '../../../helpers/constants.js';

/* eslint-disable jsx-a11y/label-has-associated-control */
/**
 * @description Nimvelo Checkbox component
 * @props kind, size, labelText, lavelPosition, color, rounded, fullWidth, inputProps, labelProps, disabled, checked
 */
const NvCheckbox = ({ kind = 'checkbox', size = 'standard', labelText, labelPosition = 'left', color = COLORS.PRIMARY, rounded = false, fullWidth = false, inputProps, labelProps, disabled = false, checked = false, onChange = () => { }, }) => {
    const [id] = useState(uniqueId('checkbox'));
    const wrapperClasses = `${styles.wrapper} ${styles[labelPosition] ?? styles.left} ${styles[size] ?? styles.standard}`;
    let content;
    const checkboxColorStyle = {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        '--NvCheckboxColor': color,
    };
    switch (kind) {
        case 'toggle':
            content = (React__default.createElement("div", { className: styles.toggle_container },
                React__default.createElement("input", { type: "checkbox", id: id, className: styles.checkbox, checked: checked, onChange: onChange, ...inputProps }),
                React__default.createElement("label", { htmlFor: id, className: styles.label, ...labelProps },
                    React__default.createElement("div", { className: styles.slider }),
                    React__default.createElement("div", { className: styles.toggle }))));
            break;
        case 'checkbox':
        default:
            content = (React__default.createElement("div", { className: styles.checkbox_container },
                React__default.createElement("input", { type: "checkbox", id: id, className: styles.checkbox, checked: checked, onChange: onChange, ...inputProps }),
                React__default.createElement("label", { htmlFor: id, className: styles.label, ...labelProps },
                    React__default.createElement("div", { className: propsToClass(styles.box, [[styles.rounded, rounded]]) },
                        React__default.createElement("svg", { viewBox: "8 8 36 36", className: styles.svg },
                            React__default.createElement("path", { className: styles.path, fill: "none", d: "M14.1 27.2l7.1 7.2 16.7-16.8" }))))));
            break;
    }
    return (React__default.createElement("div", { className: propsToClass(wrapperClasses, [
            [styles.full_width, fullWidth],
            [styles.disabled, disabled],
        ]), style: checkboxColorStyle },
        labelText && (React__default.createElement("label", { htmlFor: id, className: styles.label_text }, labelText)),
        content));
};

export { NvCheckbox, NvCheckbox as default };
//# sourceMappingURL=component.js.map
